import React, { FormEventHandler } from 'react';
import { Button } from 'react-bootstrap';
import CalenderIcon from '../../../assets/calendar.svg';
import { CloseIcon } from '../../../assets/Icon';

type DateInputShowComponentProps = {
  id: string;
  value?: string;
  placeholder: string;
  onClick: React.MouseEventHandler<HTMLElement> | undefined;
  ref: React.Ref<HTMLDivElement>;
  onChange?: FormEventHandler<HTMLButtonElement> | undefined;
};

const DateInputShowComponent: React.FC<DateInputShowComponentProps> = ({
  id,
  value,
  placeholder,
  onClick,
  ref,
  onChange,
}) => {
  const onClickHandler = (event: React.MouseEvent<HTMLElement>) => {
    onClick && onClick(event);
  };
  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        border: '1px solid #E6E9EF',
        borderRadius: '4px',
        marginTop: 2,
      }}
    >
      <input
        id={id}
        value={value}
        placeholder={placeholder}
        onClick={e => onClickHandler(e)}
        variant="outlined"
        style={{
          cursor: 'pointer',
          border: 'none',
          padding: '7px 12px 7px 20px',
          boxShadow: '0px 0px 4px 0px #0000000D',
          // maxWidth: '270px',
          // width: '180px',
          display: 'flex',
          alignItems: 'center',
          gap: '36px',
        }}
        // @ts-ignore
        ref={ref}
        className="custom-input-date"
      />
      {value ? (
        <Button
          variant="plain"
          color="light"
          className="p-1"
          onClick={e => onChange?.(e)}
        >
          <CloseIcon />
        </Button>
      ) : (
        <div onClick={e => onClickHandler(e)} style={{ cursor: 'pointer' }}>
          <img
            src={CalenderIcon}
            alt="CalenderIcon"
            style={{
              width: '23px',
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              backgroundColor: 'white',
            }}
          />
        </div>
      )}
    </div>
  );
};

export default DateInputShowComponent;
